module.exports = __webpack_public_path__ + "assets/img/news_img.435a78cc.jpg";